import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
// Import JSX Modules
import FoldedCardProductImage   from './folded-card-product-image';
import MetallicCardProductImage from './metallic-card-product-image';
import ProductImage             from './product-image';
import ProductImageThumbnail    from './product-image-thumbnail';
import ProductVideo             from './product-video';

// -----------------------------------------------------------
//  ProductImages
// -----------------------------------------------------------
var ProductImages = createReactClass({
  getInitialState() {
    return {
      index: 0
    };
  },
  render() {
    if (!this.props.product) {
      return null;
    }

    const {
      selectedTheme,
      product: {
        title: productTitle,
        theme_and_product_images: productImages
      }
    } = this.props;
    
    if (productImages.length == 0) {
      return null;
    }

    const attributes = {
      isRounded:   this.props.rounded_corners,
      isElegant:   this.props.elegant_corners,
      isScalloped: this.props.scalloped_edges,
      isCard:      this.props.product.is_card
    };

    const alt = selectedTheme ? `${productTitle} with ${selectedTheme.title} design` : productTitle;
    const optionAsset = this.customisationOptionAsset();

    const $resource = ((asset, i ) => {
      if (asset.type == 'video') {
        return <ProductVideo url={asset.url} />;
      }
      if (asset.type == 'image') {
        if (this.isProductFoldedCard())
          return <FoldedCardProductImage url={asset.url} />;

        if (this.isProductMetallicCard())
          return <MetallicCardProductImage url={asset.url} />;

        return <ProductImage key={this.state.index} 
                             url={asset.url}
                             alt={`${alt} ${i + 1}`}
                             { ...attributes }
                             optionAsset={optionAsset} />;
      }

      return (
        <div className="flex-video">
          <iframe key={ this.state.index }
                  src={ asset.url }
                  scrolling="no"
                  frameBorder="no"
                  className="img-fluid mx-auto"
                  allowFullScreen />
        </div>
      );
    })(productImages[this.state.index], this.state.index);

    const $thumbnails = productImages.map((product_image, i) => {
      return <ProductImageThumbnail key={i}
                                    { ...product_image }
                                    { ...attributes }
                                    alt={`Thumbnail for ${alt} ${i + 1}`}
                                    index={i}
                                    selected={i == this.state.index}
                                    onClick={this.handleSelected}
                                    optionAsset={optionAsset} />;
    });

    // key is used to reset the state back to zero when the selected product changes
    if ($thumbnails.length > 1) {
      return (
        <div className="thumbnails-wrapper">
          { $resource }
          <ul className="list-inline thumbnails d-flex flex-wrap justify-content-center" role="radiogroup">
            {
              $thumbnails.map(($thumbnail, i) => {
                return (
                  <li className="list-inline-item" key={ i }>
                    { $thumbnail }
                  </li>
                );
              })
            }
          </ul>
        </div>
      );
    }

    return $resource;
  },
  isProductFoldedCard() {
    return this.isProductMatch([/Folded Card/i, /Note Card/i]);
  },
  isProductMetallicCard() {
    return this.isProductMatch(/Metallic(\W*)Greeting Card/i);
  },
  isProductMatch(titleRegexes) {
    titleRegexes = [].concat(titleRegexes);

    return titleRegexes.some(regex => {
      return regex.test(this.props.product.title);
    });
  },
  customisationOptionAsset() {
    const {index} = this.state;
    const {selectedOptions = {}, productOptions = []} = this.props;
    const [{id, display_overlay_preview: displayOverlayPreview} = {}] = productOptions;
    const {[id]: {asset} = {} } = {} = selectedOptions;

    return index === 0 && displayOverlayPreview ? asset : undefined;
  },
  handleSelected(index) {
    this.setState(prevState => {
      if (index != prevState.index)
        return {
          index
        };
    });
  }
});

export default ProductImages;
